import { selectIsEditMode, selectVehicleMake } from './../../../store/service-appointment/service-appointment.selectors';
import { UpdateRecallCodes, UpdateServiceForm } from './../../../store/service-appointment/service-appointment.actions';
import { VehicleService } from './../../../shared/services/vehicle.service';
import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AppointmentFormService } from '../appointment-form.service';
import {ServiceAppointmentState} from '../../../store/service-appointment/service-appointment.reducer';
import { Store } from '@ngrx/store';
import * as fromSelectors from '../../../store/service-appointment/service-appointment.selectors';
import * as util from '../../../shared/services/util.service';
import { SubscriptionList } from '../../../shared/models/asp.types';
import { getServiceRequestValidator } from '../service-appointment.validator';
import { Department, IOpcodeRequest, IServiceOpcode, IServiceRequest, OpcodeType } from '@signal/asp-data-commons';
import { Observable, Subscription } from 'rxjs';
import { LoadServiceRequests } from '../../../store/service-appointment/service-appointment.actions';

import { MatDialog } from '@angular/material/dialog';
import { FactoryServicesDialogComponent } from '../../../shared/components/factory-services-dialog/factory-services-dialog.component';
import { FactoryPrintService } from '../../../shared/components/factory-services-dialog/factory-print.service';
import { AuthService } from './../../../shared/services/auth.service';
import * as _ from 'lodash';
import { AspRoles, countryCd } from './../../../shared/services/util.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-service',
  templateUrl: './select-service.component.html',
  styleUrls: ['./select-service.component.scss']
})
export class SelectServiceComponent implements OnInit, OnChanges, OnDestroy {

  allServices: IServiceOpcode[] = [];
  services: IServiceOpcode[] = [];
  recommendedServices: IServiceOpcode[] = [];
  recommendedServicesSelectedCount = 0;
  regularServicesSelectedCount = 0;
  openedRecommendedService;
  openedService;
  telematicsInfo;
  telematicsAlert: string;
  recallAlert: string;
  selectedServicesArr: IServiceRequest[] = [];
  isEditMode: boolean;
  isTelematicsLoading: boolean = false;
  sub: Subscription = new Subscription();
  @Input() stepIndex = 1;
  @ViewChild('clearFilter') clearFilterInput: ElementRef;
  step: UntypedFormGroup;
  service: IServiceOpcode = {} as IServiceOpcode;
  selectedServices: any[] = [];
  private subs: SubscriptionList = {};

  serviceOpcodesLoading$: Observable<boolean>;
  showPricing$: Observable<boolean>;
  recommendedServicesAvailable$: Observable<boolean>;
  otherServicesAvailable$: Observable<boolean>;
  index = 0;
  selectedStep$: Observable<number>;
  availableMileages$: Observable<number[]>;
  recommendedServicesByMileage$: Observable<number>;
  availableMileagesLoading$: Observable<boolean>;
  availableMileagesLoaded$: Observable<boolean>;
  private userRoles: string[] = [];
  languageCd: string = 'en';
  isNTL = false;
  remedyAvailable = "Remedy Available";
  isMEXDealer = countryCd === 'MEX' ? true : false;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly formService: AppointmentFormService,
    private readonly vehicleService: VehicleService,
    private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
    private readonly dialog: MatDialog,
    private readonly factoryPrintService:FactoryPrintService,
    private readonly authService: AuthService,
    private readonly translate: TranslateService
  ) {
    if(this.translate.currentLang?.includes('es')){
      this.languageCd = 'es';
    }
    this.ready();
    this.setupStore();
    this.factoryPrintService.getImage();
    this.subs.auth = authService.getEmployeeRoles().subscribe(t => {
      this.userRoles = t
    });
  }

  _isAuthenticated() {
    const requiredRoles=[...AspRoles]
    const authorized = _.every(requiredRoles, (t) => this.userRoles.indexOf(t) >= 0);
    if (authorized) {
        return true;
    }
    return false;
}

  get f() {
    return this.step && this.step.controls;
  }

  get servicesFormArr(): UntypedFormArray {
    return this.f && this.f.servicesFormArr as UntypedFormArray;
  }

  get recommendedServicesArr() {
    return this.step.get('recommendedServices') as UntypedFormArray;
  }

  get allServicesArr() {
    return this.step.get('allServices') as UntypedFormArray;
  }

  getAddOns(index, isRecommendedSec){
    if(isRecommendedSec){
      const recommendedFormControl = this.recommendedServicesArr.controls[index].get('addOns') as UntypedFormArray;
      return recommendedFormControl.controls ;
    }else{
      const recommendedFormControl = this.allServicesArr.controls[index].get('addOns') as UntypedFormArray;
      return recommendedFormControl.controls ;
    }
  }

  get addOnServicesArr() {
    return this.step.get('addOnServices') as UntypedFormArray;
  }

  mapItems() {
    const servicesSelected: any[] = this.allServicesArr.value?.filter((item) => item.selected).map((item) => item.id);
    const recommendedServicesSelected: any[] = this.recommendedServicesArr.value?.filter((item) => item.selected).map((item) => item.id);
    return servicesSelected.length + recommendedServicesSelected.length ? '1' : null;
  }

  ngOnInit(): void {
  }

  getSubComplaints(com)
  {
    return com?.subComplaints?.complaintCodes.filter(x=>x.online);
  }

  ngOnChanges(change: any) {
    this.stepIndex = change.stepIndex.currentValue;
  }

  collapseOthers(isrecommendedSection: boolean, index) {
    if (isrecommendedSection) {
      this.openedRecommendedService = index;
    } else {
      this.openedService = index;
    }
  }

  checkEvent(e) {
    e.stopPropagation();
  }

  selectionChange(e, isrecommendedSection: boolean, index) {
    let serv : IServiceOpcode;
    if (isrecommendedSection) {
      this.recommendedServicesArr.controls[index].get('expanded').setValue(e.checked);
      serv = this.recommendedServicesArr.controls[index].get('serviceInfo').value;
    } else {
      this.allServicesArr.controls[index].get('expanded').setValue(e.checked);
      serv = this.allServicesArr.controls[index].get('serviceInfo').value;
    }
    this.updateAddOnSelection(serv, e.checked);
    if(!e.checked && !serv?.isInternalCode && !serv?.isDmsApptOpcode){
        if(serv.addOnOpcodes?.checked && serv.addOnOpcodes.opcodes && serv.addOnOpcodes.opcodes.length > 0){
          serv.addOnOpcodes.opcodes.forEach(addOn => {
            this.updateAddOnSelection(addOn.opcodeDetails, e.checked);
          });
        }
      }
  }

  updateAddOnSelection(service: IServiceOpcode, isSelected: boolean) {
    const allServiceGroups = [...this.recommendedServicesArr.controls, ...this.allServicesArr.controls];
    allServiceGroups.forEach(serviceControl => {
      const formArr = serviceControl.get('addOns') as UntypedFormArray;
      if (!formArr || !formArr.controls) return;
      let isTargetChildFound = false;
      formArr.controls.forEach(childControl => {
        const childService = childControl.get('serviceInfo')?.value;
        if (childService?.opcode === service.opcode) {
          childControl.get('selected')?.patchValue(isSelected);
          isTargetChildFound = true;
        }
      });
  
      if (isTargetChildFound) {
        const anyChildSelected = formArr.controls.some(c => c.get('selected')?.value === true);
        serviceControl.get('selected')?.patchValue(anyChildSelected);
        serviceControl.get('expanded')?.patchValue(anyChildSelected);
      }
    });
  
    this.recommendedServicesArr.controls.forEach(x => {
      if (x.get('serviceInfo')?.value?.opcode === service.opcode) {
        x.get('selected')?.patchValue(isSelected);
      }
    });
  
    this.allServicesArr.controls.forEach(x => {
      if (x.get('serviceInfo')?.value?.opcode === service.opcode) {
        x.get('selected')?.patchValue(isSelected);
        const formData = x.get('serviceInfo')?.value;
        if (formData?.isInternalCode && !isSelected) {
          const formArr = x.get('addOns') as UntypedFormArray;
          formArr?.controls?.forEach(c => {
            c.get('selected')?.patchValue(false);
          });
        }
      }
    });
  }

  addOnSelectionChange(e, isRecommendedSec, addOnVal: IServiceOpcode) {
    this.updateAddOnSelection(addOnVal, e.checked);
  }

  filterServices(filterValue: string) {
    const val = filterValue?.toLocaleLowerCase();
    this.allServicesArr.controls.forEach(t => {
      if (val && val !== '' && t.get('serviceInfo').value.displayName.toLocaleLowerCase().indexOf(val) < 0
        && t.get('serviceInfo').value.description.toLocaleLowerCase().indexOf(val) < 0) {
        t.get('hidden').patchValue(true);
      } else {
        t.get('hidden').patchValue(false);
      }
    });
  }

  clearServiceFilter() {
    this.clearFilterInput.nativeElement.value = '';
    this.filterServices('');
  }

  clearSelections() {
    this.allServicesArr.controls.forEach(item => {
      item.get('expanded').setValue(false);
      this.updateAddOnSelection(item.get('serviceInfo').value, false);
      if( item.get('serviceInfo').value?.addOnOpcodes?.checked && item.get('serviceInfo').value?.addOnOpcodes?.opcodes){
      item.get('serviceInfo').value?.addOnOpcodes?.opcodes?.forEach(addOn => {
        this.updateAddOnSelection(addOn.opcodeDetails, false);
      });
    }
    });
    this.regularServicesSelectedCount = 0;
  }

  ready() {

    this.serviceOpcodesLoading$ = this.serviceAppointmentState.select(fromSelectors.selectServiceOpcodesLoading);
    // this.showPricing$ = this.serviceAppointmentState.select(selectServiceShowPricing);
    this.recommendedServicesAvailable$ = this.serviceAppointmentState.select(fromSelectors.selectRecommendedServiceOpcodesAvailable);
    this.otherServicesAvailable$ = this.serviceAppointmentState.select(fromSelectors.selectOtherServiceOpcodesAvailable);
    this.selectedStep$ = this.serviceAppointmentState.select(fromSelectors.selectCurrentStep);
    this.availableMileages$ = this.serviceAppointmentState.select(fromSelectors.selectAvailableMileagesData);
    this.recommendedServicesByMileage$ = this.serviceAppointmentState.select(fromSelectors.selectServiceOpcodesRecommendedMileage);
    this.availableMileagesLoading$ = this.serviceAppointmentState.select(fromSelectors.selectAvailableMileagesLoading);
    this.availableMileagesLoaded$ = this.serviceAppointmentState.select(fromSelectors.selectAvailableMileagesLoaded);

    this.step = this.formBuilder.group({
      recommendedServices: this.formBuilder.array([]),
      allServices: this.formBuilder.array([]),
      addOnServices: this.formBuilder.array([]),
      selectedServices: [[], null],
      isInitialState: false
    });

    this.step.setValidators(getServiceRequestValidator());

    this.subs.validateServiceSub = this.formService.validateServices.subscribe(t => {
      this.recommendedServicesArr.controls.forEach(service => {
        if (!service.valid) {
          service.get('expanded').patchValue(true);
        }
      });
      this.allServicesArr.controls.forEach(service => {
        if (!service.valid) {
          service.get('expanded').patchValue(true);
        }
      });
    });

  }

  ngOnDestroy(): void {
    util.unsubscribeSubscriptions(this.subs);
  }

  private buildRecommendedServicesFormArray() {
    this.recommendedServicesArr.clear();
    this.selectedServicesArr = [];
    this.recommendedServices.forEach((rs: IServiceOpcode) => {

      let isSelected = false;
      let comments;
      const serv = { ...rs };
      if (!!rs.recommended && rs.recommended.isTelematics) {
        if (!this.telematicsAlert)  {
            return;
          }
        else {
          comments = serv.description = this.telematicsAlert;
          isSelected = true;
        }
      }
      else if (!!rs.recommended && rs.recommended.isSSCRecall) {
        if (!this.recallAlert)  {
            return;
          }
        else {
          comments = serv.description = this.recallAlert;
          isSelected = true;
        }
      }
      const selService: IServiceRequest = { opcode: rs.opcode, comments, details: rs };

      const selectedService = this.findSelectedService(rs);
      isSelected = this.isEditMode ? false : isSelected;
      if (isSelected) {
        this.selectedServicesArr.push(selService);
      }
      const addOnArr: UntypedFormArray = new UntypedFormArray([]);
      if(serv.addOnOpcodes && serv.addOnOpcodes.opcodes){
        serv.addOnOpcodes.opcodes.forEach(x=> {
          let selectedAddOn = false;
          if(selectedService){
          selectedAddOn = this.findSelectedService(x.opcodeDetails);
          }
          const addOnServiceItem = this.formBuilder.group({
            selected: [!!selectedAddOn],
            serviceInfo: [x.opcodeDetails],
            addOns: this.formBuilder.array([]),
            comments: null,
            hidden: [false],
            expanded: [false]
          });
          addOnArr.push(addOnServiceItem);
        });
      }
      const serviceItem = this.formBuilder.group({
        selected: [!!selectedService],
        serviceInfo: [serv],
        addOns: addOnArr,
        comments: this.formBuilder.control({ value: (comments ? comments : (selectedService && selectedService.comments) || ''), disabled: !rs.commentsEnabled}),
        expanded: [false]
      });
      if (!!rs.opcodeType || rs.opcodeType === OpcodeType.OTHER) {
        this.subs.serviceSelectionSub = (serviceItem.get('selected') as UntypedFormControl).valueChanges
          .subscribe(this.setCommentsValidator(serviceItem, rs));
      }
      this.recommendedServicesArr.push(serviceItem);
      this.buildAddOnServiceArray(rs, isSelected);
    });
    if (this.selectedServicesArr.length > 0 || !this.isEditMode) {
      this.serviceAppointmentState.dispatch(new UpdateServiceForm({ path: 'serviceForm', value: { selectedServices: this.selectedServicesArr } }));
    }
  

    this.subs.recommenedServiceSub = this.recommendedServicesArr.valueChanges.subscribe(t => {
      this.recommendedServicesSelectedCount = this.recommendedServicesArr.value?.filter((item) => item.selected).length;
    });
  }

  private buildAddOnServiceArray(service: IServiceOpcode, selectedService: boolean){
    if(service.addOnOpcodes && service.addOnOpcodes.checked &&  service.addOnOpcodes.opcodes && service.addOnOpcodes.opcodes.length > 0){
      service.addOnOpcodes.opcodes.forEach(serv => {
        const index = this.addOnServicesArr.controls.findIndex(x => x.get('serviceInfo').value.opcode === serv.opcodeDetails.opcode);
        if(index === -1){
          let selectedAddOn = false;
          if(selectedService){
          selectedAddOn = this.findSelectedService(serv.opcodeDetails);
          }
          const serviceItem = this.formBuilder.group({
            selected: [!!selectedAddOn],
            serviceInfo: [serv.opcodeDetails],
            comments: null,
            hidden: [false],
            expanded: [false]
          });
          this.addOnServicesArr.push(serviceItem);
        }
      })
    }
  }

  private buildAllServicesFormArray() {
    this.allServicesArr.clear();
    this.services.forEach((s,index) => {
      const selectedService = this.findSelectedService(s);
      const addOnArr: UntypedFormArray = new UntypedFormArray([]);
      if(s.addOnOpcodes && s.addOnOpcodes.opcodes){
        s.addOnOpcodes.opcodes.forEach(x=> {
          let selectedAddOn = false;
          if(selectedService){
          selectedAddOn = this.findSelectedService(x.opcodeDetails);
          }
          const addOnServiceItem = this.formBuilder.group({
            selected: [!!selectedAddOn],
            serviceInfo: [x.opcodeDetails],
            addOns: this.formBuilder.array([]),
            comments: null,
            hidden: [false],
            expanded: [false]
          });
          addOnArr.push(addOnServiceItem);
        });
      }
      else if(s.subComplaints && s.subComplaints.complaintCodes && s.subComplaints.complaintCodes.length){
        const onlineSubComplaints=this.getSubComplaints(s);
        onlineSubComplaints.forEach(x=> {
          let selectedAddOn = false;
          if(selectedService){
          selectedAddOn = this.findSelectedsubComplaints(x);
          }    
          const addOnServiceItem = this.formBuilder.group({
            selected: [selectedAddOn],
            serviceInfo: [x],
            addOns: this.formBuilder.array([]),
            comments: null,
            hidden: [false],
            expanded: [false]
          });
          addOnArr.push(addOnServiceItem);
        });
      }
      const serviceItem = this.formBuilder.group({
        selected: [!!selectedService],
        serviceInfo: [s],
        addOns: addOnArr,
        comments: this.formBuilder.control({ value: selectedService && selectedService.comments, disabled: this._isAuthenticated()? false :!s.isMiscellaneous && !s.commentsEnabled}),
        hidden: [false],
        expanded: [false]
      });
      this.subs['allServiceSelectedSub' + index] = (serviceItem.get('selected') as UntypedFormControl).valueChanges
        .subscribe(this.setCommentsValidator(serviceItem, s));
      this.allServicesArr.push(serviceItem);
      this.buildAddOnServiceArray(s, !!selectedService);
    });

    this.subs.allServicesChangeSub = this.allServicesArr.valueChanges.subscribe(t => {
      this.regularServicesSelectedCount = this.allServicesArr.value?.filter((item) => item.selected).length;
    });
  }

  findSelectedService(s) {
    return this.selectedServices.find(md =>(md?.internalCode ) ? ( (md?.internalCode !=="") ? (md.internalCode === s.opcode) : (md.opcode === s.opcode)) : (md.opcode === s.opcode) );
  }

  findSelectedsubComplaints(subComplaint) {
    let check = false;
    this.selectedServices.forEach(sub => {
      if(sub?.details?.isInternalCode && sub?.subComplaints)
      {
        sub.subComplaints.forEach(x => {
          if (x.opcode === subComplaint.opcode) {
            check = true;
          }
        });
      }
    });
    return check;
  }

  private setCommentsValidator(serviceItem, rs) {
    return checked => {
      const commentsItem = serviceItem.get('comments') as UntypedFormControl;
      if (checked && rs.commentsEnabled && rs.commentsRequired) {
        commentsItem.setValidators([Validators.required]);
      } else {
        commentsItem.setValidators([]);
      }
      commentsItem.updateValueAndValidity();
    };
  }

  private setupStore() {

    this.subs.editmode = this.serviceAppointmentState.select(selectIsEditMode).subscribe(t => {
      this.isEditMode = t;
    });
    
    this.subs.editmode = this.serviceAppointmentState.select(selectVehicleMake).subscribe(t => {
      this.isNTL = t?.toUpperCase() === 'OTHER';
    });

    this.subs.serviceFormSub = this.serviceAppointmentState.select(fromSelectors.selectServiceFormSelectedServices)
      .subscribe((selectedServices) => {
        this.selectedServices = selectedServices;
      });

    this.subs.vin = this.serviceAppointmentState.select(fromSelectors.selectVehicleFormVin).subscribe(t => {
      if (t && t.length === 17) {
        this.isTelematicsLoading = true;
        this.sub = this.vehicleService.getTelematics(t,Department.SERVICE).subscribe(telematics => {
          this.telematicsAlert = undefined;
          this.recallAlert = undefined;
          this.telematicsInfo = telematics.data;
          if (this.telematicsInfo?.vehicleHealthStatus?.warningsList && this.telematicsInfo?.vehicleHealthStatus?.warningsList?.length > 0) {
            this.telematicsAlert = '';
            for (const warning of this.telematicsInfo.vehicleHealthStatus.warningsList) {
              this.telematicsAlert += warning.desc + '; ';
            }
            this.telematicsAlert = this.telematicsAlert.substring(0, this.telematicsAlert.length - 2);
          }
        let recallCodes;
          if (this.telematicsInfo?.sscPayload?.specialServiceCampaigns && this.telematicsInfo?.sscPayload?.specialServiceCampaigns?.length > 0) {
            this.recallAlert = '';
            recallCodes = [];
            for (const recall of this.telematicsInfo.sscPayload.specialServiceCampaigns) {
              if(recall.remedyAvailable === this.remedyAvailable){
                this.recallAlert += recall.sscDescription + '; ';
                recallCodes.push(recall.sscCode);
              }
            }
            this.recallAlert = this.recallAlert.substring(0, this.recallAlert.length - 2);
          }
          this.serviceAppointmentState.dispatch(new UpdateRecallCodes({ recallCodes }));
          this.buildRecommendedServicesFormArray();
          this.isTelematicsLoading = false;
          this.sub?.unsubscribe();
        },
          error => {
            this.telematicsAlert = undefined;
            this.recallAlert = undefined;
            this.telematicsInfo = undefined;
            this.isTelematicsLoading = false;
          });
      }
    });

    this.subs.recommendedServiceRequestsSub = this.serviceAppointmentState.select(fromSelectors.selectRecommendedServiceOpcodes)
      .subscribe((serviceRequestData) => {
        this.recommendedServices = serviceRequestData;
        this.buildRecommendedServicesFormArray();
      });

    this.subs.otherServiceRequestsSub = this.serviceAppointmentState.select(fromSelectors.selectOtherServiceOpcodes)
      .subscribe((serviceRequestData) => {
        this.services = serviceRequestData;
        this.updateAllServiceArray(this.services);
        this.buildAllServicesFormArray();
      });
  }

  generatePTagsSSCrecall(serviceInfo): string[] {
    if(serviceInfo?.recommended?.isSSCRecall) {
      return serviceInfo.description.split('; ');
    } else {
      return Array.isArray(serviceInfo.description) ? serviceInfo.description : [serviceInfo.description];
    } 
  }  

  updateAllServiceArray(services) {
    /** this part of code is used to add dms appt opcode to normal services array */
    this.selectedServices = this.selectedServices.map(data => {
      const opcode = (data.internalCode) ? data.internalCode : data.opcode;
      const res = services.find(serviceData => serviceData.opcode === opcode);
      if (!res) {
        const newData = {
          ...data,
          details: {
            ...data.details,
            isDmsApptOpcode: true
          }
        };
        this.services = [newData.details, ...this.services];
        return newData;
      }
      return data;
    });
    
    if (this.selectedServices.length > 0) {
      this.serviceAppointmentState.dispatch(new UpdateServiceForm({ path: 'serviceForm', value: { selectedServices: this.selectedServices } }));
    }
  }

  getPricing(serviceOpcode: IServiceOpcode) {
    return util.getOpcodePricing(serviceOpcode);
  }

  getPricingText(serviceOpcode: IServiceOpcode) {
    return this.opCodePricingTranslation(util.getOpcodePricingText(serviceOpcode));
  }

  isLexusDealer(serviceInfo: any): boolean {
    return !!serviceInfo?.dealerCode?.toString().startsWith('6');
  }

  onMileageChange(mileage: number) {
    this.subs.vehicleform = this.serviceAppointmentState.select(fromSelectors.selectVehicleForm).subscribe(data=>{
      const opcodeRequest: IOpcodeRequest = { mileage: +mileage ,
        make : data.make,
        model : data.model,
        year : data.year?.toString(),
        vin : data.vin,
      }
      if(opcodeRequest.mileage > 0){
        this.serviceAppointmentState.dispatch(new LoadServiceRequests({ opcodeRequest, countryCode: util.countryCd.toUpperCase() === 'USA' ? 'US' : 'MX', languageCode: this.languageCd }));
      }
    })
  }
  viewFactoryDetails(e, service) {
    this.dialog.open(FactoryServicesDialogComponent, {
      maxWidth: '90%',
      height: '70%',
      data: service,
      width:'80%'
    });
    e.stopPropagation();
  }
  setMiscSelected(service: UntypedFormGroup) {
    const isSelected = service.get('selected').value;
    const shouldSelect = !!service.value.comments?.trim().length;
    if (shouldSelect && !isSelected) {
      service.get('selected').setValue(true);
    }
    else if (!shouldSelect && isSelected) {
      service.get('selected').setValue(false);
    }
  }
  opCodePricingTranslation(text){
    if(text){
      text = text.replace('Starts at', this.translate.instant('opcodeServiceManagement.startsAt'));
      text = text.replace('Ranges from', this.translate.instant('opcodeServiceManagement.rangesFrom'));
    }
    return text;
  }
}
